import type { ApprovalRequest } from '@secretario/shared';
import { actOnApproval } from './api/personal.js';
import { getProfile } from './api/profile.js';
import { readSession } from './session.js';

/**
 * Aprovar um pedido. Quando ele é o rascunho de uma resposta numa conversa do
 * mensageiro, a mensagem sai primeiro (como fala do Secretário, visível para
 * todos) e só depois o pedido é dado como resolvido: se o envio falhar, ele
 * continua esperando.
 */
/**
 * Chamado do Secretário ao dono (cliente pediu algo que só o dono resolve):
 * não há rascunho para aprovar, o dono responde direto na conversa.
 */
export function isOwnerCall(request: ApprovalRequest): boolean {
  return !request.draft?.trim() && !!request.roomId;
}

export async function approveWithDelivery(
  request: ApprovalRequest | undefined,
  id: string,
  instruction?: string,
): Promise<void> {
  const text = (instruction ?? request?.draft ?? '').trim();
  if (request?.roomId && text) {
    const [{ ensureMatrixClient }, rooms, profile] = await Promise.all([
      import('./matrix/client.js'),
      import('./matrix/rooms.js'),
      getProfile(),
    ]);
    const client = await ensureMatrixClient();
    if (!client) throw new Error('Não consegui abrir o mensageiro agora. Tenta de novo?');
    const session = readSession();
    await rooms.postAssistantMessage(client, request.roomId, {
      text,
      request: '',
      name: profile.secretaryName?.trim() || 'Secretário',
      characterKey: profile.characterKey,
      ownerName: profile.nickname?.trim() || session?.user.displayName.split(' ')[0] || '',
    });
  }
  await actOnApproval(id, 'approve', instruction);
}
